<template>
    <div>
        <!-- Instituição só aparece quando não houve pré-seleção (perfil SMED) -->
        <el-form label-position="top" @submit.native.prevent>
            <el-row :gutter="10" v-if="ehSmed" class="u-mt-20">
                <el-col :sm="24">
                    <el-form-item label="Instituição (almoxarifado)">
                        <el-select v-model="form.instituicao_id" filterable placeholder="Selecione a instituição" style="width:100%;">
                            <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-form label-position="top" @submit.native.prevent>
            <el-row :gutter="10">
                <el-col :sm="14">
                    <el-form-item label="Produto">
                        <el-select v-model="form.produto_id" filterable remote :remote-method="q => $emit('buscar-produto', q)" placeholder="Digite..." style="width:100%;">
                            <el-option v-for="p in produtos" :key="p.id" :label="p.codigo + ' — ' + p.nome" :value="p.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :sm="10">
                    <el-form-item label="Quantidade">
                        <el-input-number v-model="form.quantidade" :min="0.001" :precision="3" style="width:100%;"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-form label-position="top" @submit.native.prevent>
            <el-row :gutter="10">
                <el-col :sm="12">
                    <el-form-item label="Lote (opcional)"><el-input v-model="form.lote"></el-input></el-form-item>
                </el-col>
                <el-col :sm="12">
                    <el-form-item label="Validade">
                        <el-date-picker v-model="form.validade" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-form label-position="top" @submit.native.prevent>
            <el-row :gutter="10">
                <el-col :sm="24">
                    <el-form-item label="Documento (NF/Requisição)"><el-input v-model="form.documento"></el-input></el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-form label-position="top" @submit.native.prevent>
            <el-row :gutter="10">
                <el-col :sm="24">
                    <el-form-item label="Observação"><el-input type="textarea" v-model="form.observacao" :rows="2"></el-input></el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ['form', 'produtos', 'ehSmed', 'instituicoes']
}
</script>
